import { Component, OnInit, Input, forwardRef, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'achoo-chips',
    templateUrl: './achoo-chips.component.html',
    styleUrls: ['./achoo-chips.component.scss']
})
export class AchooChipsComponent {
    @Input()
    chips: string[];

    @Input()
    processingChips: string[] = [];

    @Input()
    errorChips: string[] = [];

    @Input()
    editable = false;

    @Input()
    material = false;

    @Output()
    deleteItem = new EventEmitter<any>();

    onItemRemove(index: number) {
        this.deleteItem.emit(index);
    }

    isProgressingChip(chip: string) {
      if (!this.processingChips) {
        return false;
      }
      return this.processingChips.findIndex(pc => pc === chip) >= 0;
    }

    isErrorChip(chip: string) {
      if (!this.errorChips) {
        return false;
      }
      return this.errorChips.findIndex(pc => pc === chip) >= 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-chips/achoo-chips.component.ts